<div *ngIf="isSelectedInvoluntary">
  <div class="column">
    <app-alert type="warning">
      <span class="weight-medium" title>
        {{ 'shared.warning' | translate }}
      </span>
      <div description>
        {{ 'itinerary-actions.affectation-involuntary-change' | translate }}
      </div>
    </app-alert>
  </div>
</div>

<div class="columns is-mobile pb-2 is-vcentered">
  <div class="column is-3 pl-0">
    <form [formGroup]="actionForm">
      <app-input-select
        size="medium"
        [form]="actionForm"
        (changeOption)="changeAction(true)"
        inputName="actionType"
        [value]="actionType"
        [affectationAvailable]="existAffectation"
        [values]="ACTION_TYPES"
        [translate]="true"
        [id]="'selectActions'"
        [disabled]="loadingActions || currentProcess$"
        label="{{ 'itinerary-actions.title' | translate }}"
        placeholder="{{ 'itinerary-actions.placeholder' | translate }}"
      ></app-input-select>
    </form>
  </div>

  <div class="column pt-4 mt-1">
    <app-instruction-message-action-selected
      [selectedMode]="actionType"
      [selectedPassengersQuote]="selectedPassengersQuote"
      [selectedSegments]="selectedSegments"
      [hasPendingChanges]="hasPendingChanges"
      [somePassengerHasTicket]="somePassengerHasTicket"
    >
    </app-instruction-message-action-selected>
  </div>

  <div class="columns is-2 pt-4 mt-1">
    <div *ngIf="isReRoute" class="column">
      <app-input-submit
        inputText="{{ 're-route.name' | translate }}"
        type="submit"
        [disabled]="
          reRouteDisabled ||
          this.selectedPassengersHasInvalidCoupons ||
          !this.receivedFromHasValue ||
          this.validateWarnings()
        "
        (clickButton)="reRouteModalQuote()"
      ></app-input-submit>
    </div>

    <div class="column">
      <span
        attr.data-title-long="{{
          !somePassengerHasTicket ? ('itinerary-actions.not-emited' | translate) : ''
        }}"
        [class.hide-tooltip]="somePassengerHasTicket"
      >
        <app-input-submit
          inputText="{{ 'shared.continue' | translate }}"
          type="submit"
          (clickButton)="validateSendQuoteRequest()"
          [disabled]="buttonDisabled"
          [isLoading]="loadingActions"
          title="{{ tooltipMessage | translate }}"
        ></app-input-submit>
      </span>
    </div>
  </div>
</div>

<ng-container *ngIf="isModalOpen">
  <app-modal
    [isActive]="isModalOpen"
    isLarge="true"
    [enableFooter]="false"
    [showCloseFooter]="false"
    (modalState)="isModalOpen = false"
  >
    <p class="modal-card-title" modal-title>
      {{ 'exception-mode.modal-title-exception-mode' | translate }}
    </p>
    <div modal-content>
      <app-exception-form
        [isAirline]="isAirline"
        [selectedMode]="actionType"
        (exceptionData)="onSubmitExceptionForm($event)"
      ></app-exception-form>
    </div>
    <div modal-footer>
      <div class="columns">
        <div class="column is-2 is-offset-10">
          <button
            (click)="confirmAction(actionType)"
            class="button is-link is-rounded is-fullwidth"
          >
            {{ 'shared.continue' | translate }}
          </button>
        </div>
      </div>
    </div>
  </app-modal>
</ng-container>

<app-re-route-modal
  [isAirline]="isAirline"
  [showInfantWarning]="showInfantWarning"
  [isActive]="showReRouteModal"
  (closeModal)="closeReRouteModal()"
  (sendData)="saveReRouteModalData($event)"
>
</app-re-route-modal>

<app-alert-messages-modal
  [isActive]="showAlertsModal"
  [alertMessages]="alertMessages"
  [totalAlerts]="alertMessages.length"
  (closeModal)="closeAlertsModal()"
  (allMessagesAcepted)="allMessagesAcepted()"
></app-alert-messages-modal>

<app-modal
  [isActive]="showCanVoluntaryChange"
  [showAcceptFooter]="false"
  (acceptState)="exit()"
  (modalState)="exit()"
>
  <p class="modal-card-title" modal-title>
    <em class="mdi mdi-message-alert has-text-warning mdi-18px" aria-hidden="true"></em>
    {{ 'shared.warning' | translate }}
  </p>

  <div modal-content>
    <div>
      <p>
        <em class="has-text-warning mdi-18px" aria-hidden="true"></em>
        {{ 'shared.pnrNotAllowVoluntaryChange' | translate }}
      </p>
    </div>
  </div>
</app-modal>
